/* BottomPanel.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @compiled/no-suppress-xcss */
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _11 = "@media (hover:hover){._1rjn166n:hover{background-color:var(--ds-background-neutral-subtle-hovered,#091e420f)}._13kh1dty:active{background-color:var(--ds-background-neutral-subtle-pressed,#091e4224)}}";
const _10 = "._1di61dty:active{background-color:var(--ds-background-neutral-subtle-pressed,#091e4224)}";
const _9 = "._80omtlke{cursor:pointer}";
const _8 = "._1bsb1osq{width:100%}";
const _7 = "._vwz41k92{line-height:1.25rem}";
const _6 = "._1wyb1j6v{font-size:1rem}";
const _5 = "._4t3i1jfw{height:var(--ds-space-500,40px)}";
const _4 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _3 = "._bfhksm61{background-color:var(--ds-background-neutral-subtle,#00000000)}";
const _2 = "._19itglyw{border:none}";
const _ = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const bottomPanelStyles = xcss({
  flex: 0,
  padding: 'space.200',
  borderTopColor: 'color.border',
  borderTopWidth: 'border.width',
  borderTopStyle: 'solid',
  boxShadow: 'elevation.shadow.overflow'
});

// Using styled button instead of Pressable so we can use hover media query
const ClearAllButton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko12b0 _19itglyw _bfhksm61 _syaz1fxt _4t3i1jfw _1wyb1j6v _vwz41k92 _1bsb1osq _80omtlke _1di61dty _1rjn166n _13kh1dty", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ClearAllButton.displayName = 'ClearAllButton';
}
const applyButtonStyles = xcss({
  backgroundColor: 'color.background.brand.bold',
  color: 'color.text.inverse',
  height: 'size.400',
  fontSize: '1rem',
  lineHeight: '1.25rem',
  borderRadius: 'radius.small',
  width: '100%',
  ':hover': {
    backgroundColor: 'color.background.brand.bold.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.brand.bold.pressed'
  }
});
export const BottomPanel = _ref2 => {
  let {
    onApplyFilters,
    onClearAllFilters
  } = _ref2;
  return /*#__PURE__*/_jsxs(Inline, {
    spread: "space-between",
    xcss: bottomPanelStyles,
    space: "space.200",
    children: [/*#__PURE__*/_jsx(ClearAllButton, {
      onClick: onClearAllFilters,
      children: "Clear all"
    }), /*#__PURE__*/_jsx(Pressable, {
      onClick: onApplyFilters,
      xcss: applyButtonStyles,
      children: "Apply"
    })]
  });
};